import React, { useState, useEffect } from "react"
import { navigate } from 'gatsby';
import { useForm, ValidationError } from "@formspree/react";
import SuccessMessage from "./SuccessMessage"

// function useSetTimeout(timeoutCallback, seconds) {
//     const timeoutId = useRef();

//     useEffect(() => {
//         timeoutId.current = setTimeout(timeoutCallback, seconds);
//         return () => clearTimeout(timeoutId.current);
//     }, [])
// }

const Contact = () => {
  // Netlify Forms
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    message: "",
    topic: "",
  })

  // const encode = data => {
  //   return Object.keys(data)
  //     .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
  //     .join("&")
  // }

  const handleChange = e => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    })
  }

  // const handleSubmit = e => {
  //   fetch("/", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: encode({ "form-name": "Contact Form", ...formState }),
  //   })
  //     .then(() => alert("Success!"))
  //     .catch(error => alert(error))

  //   e.preventDefault()
  // }
  const [showModal, setShowModal] = useState(false)
  const [redirectNow, setRedirectNow] = useState(false);
  
  const [state, handleSubmit] = useForm(`${process.env.GATSBY_CONTACT_FORM}`, {
    data: {
      subject: `${formState.name} just contacted you!`,
      pageTitle: function() {
        // This function will be evaluated at submission time
        return document.title;
      }
    },
    // client: client,
    debug: true
  });
  if (state.succeeded) {
    return (
      <div id="success">
        <SuccessMessage name={formState.name} type={true} />
      </div>
    );
  }
  return (
    <section
      id="contactForm"
      className="flex flex-col items-center justify-center w-full mx-auto min-h-screen bg-gradient-to-br from-purple-300 via-indigo-200 to-teal-200 dark:from-gray-700 dark:via-gray-900 dark:to-black background-animate shadow-inner "
    >
      <div className="w-full lg:w-1/2 xl:w-6/12 mx-auto bg-primary shadow-2xl rounded-lg py-10 lg:py-16 lg:px-12 my-24">
        {/* Get In Touch */}
        <p className="font-body2 text-3xl md:text-4xl lg:text-5xl font-bold mb-12 uppercase text-center tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white">
          Get in touch
        </p>
        <p className="mt-6 font-body2 text-center text-secondary-text px-6 md:font-light text-xs sm:text-md md:text-lg lg:text-xl font-medium mb-5 md:mb-10 lg:mb-12">
          If you wanna get in touch, talk to me about a project collaboration or
          just say hi. Fill up the awesome form below and ~let's talk.
        </p>
        <p className="mt-6 font-body2 text-center text-danger px-6 md:font-light text-xs sm:text-md md:text-lg lg:text-xl font-medium">
          {state.errors.length > 0 ? `${formState.email} is an invalid email :(` : ""}
        </p>
        <div className="flex items-center justify-center">
          {/* Contact Form */}
          <div className=" w-full px-6 flex flex-col items-center justify-center ">
            <div className="mt-8 w-full">
              <form
                onSubmit={handleSubmit}
                // action="https://formspree.io/f/abcdefg" method="POST"
                name="Contact Form"
                // method="POST"
                // action="/success"
                // data-netlify="true"
                // data-netlify-honeypot="bot-field"
              >
                {/* <input type="hidden" name="form-name" value="Contact Form" /> */}
                <div className="grid grid-cols-1 gap-6">
                  <div className="">
                    <label htmlFor="name" className="block mb-1 ml-1 font-body2">
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      name="name"
                      className="block w-full p-2 rounded-xl focus:outline-none focus:ring focus:ring-opacity-25 focus:ring-violet-400 hover:border-blue-500 dark:hover:border-gray-400 dark:bg-secondary"
                      placeholder="Enter your name"
                      onChange={handleChange}
                      value={formState.name}
                      required
                    />
                    <ValidationError prefix="Name" field="name" errors={state.errors} code={state.errors} />
                  </div>
                  <div className="">
                    <label htmlFor="email" className="block mb-1 ml-1 font-body2">
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      className="block w-full p-2 rounded-xl focus:outline-none focus:ring focus:ring-opacity-25 focus:ring-violet-400 hover:border-blue-500 dark:hover:border-gray-400 dark:bg-secondary"
                      placeholder="john@example.com"
                      onChange={handleChange}
                      value={formState.email}
                      required
                    />
                    <ValidationError prefix="Email" field="email" errors={state.errors} code={state.errors} />
                  </div>
                  {/* <div>
                    <label className="block mb-1 ml-1">
                      What are you contacting for?
                    </label>
                    <div class="relative inline-flex">
                      <select
                        class="block rounded w-full pl-5 pr-10 focus:ring focus:ring-opacity-25 focus:ring-violet-600 dark:bg-secondary hover:border-blue-500 dark:hover:border-gray-400 focus:outline-none appearance-none"
                        name="topic[]"
                        // onChange={handleChange}
                        required
                      >
                        <option value="Hi">Say Hi!</option>
                        <option value="Review">Website Review</option>
                        <option value="Business">Business</option>
                        <option value="Other">Other</option>
                      </select>
                    <ValidationError prefix="Topic" field="topic" errors={state.errors} />
                    </div>
                  </div> */}
                  <div className="">
                    <label htmlFor="message" className="block mb-1 ml-1 font-body2">Your message</label>
                    <textarea
                      id="message"
                      name="message"
                      type="text"
                      placeholder="Message..."
                      className="block w-full p-2 autoexpand resize-y rounded-xl focus:outline-none focus:ring focus:ring-opacity-25 focus:ring-violet-400 hover:border-blue-500 dark:hover:border-gray-400 dark:bg-secondary"
                      rows="2"
                      value={formState.message}
                      onChange={handleChange}
                      required
                    />
                    <ValidationError prefix="Message" field="message" errors={state.errors} code={state.errors} />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={state.submitting}
                  className='relative inline-block w-auto text-sm md:text-md md:text-lg lg:text-xl cursor-pointer focus:outline-none font-semibold lg:font-bold shadow-xl shadow-blue-500/20 dark:shadow-teal-100/10 rounded-full transition duration-300 ease-in-out transform hover:-translate-y-1 bg-gradient-to-r from-sky-400 to-blue-500 hover:from-sky-300 hover:to-blue-400 dark:from-rose-100 dark:to-teal-100 dark:hover:from-rose-50 dark:hover:to-teal-50 mt-10'>
                    <div class="flex flex-cols-1">
                        <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-primary px-5 py-3 space-x-2 md:px-8 md:py-4 md:space-x-3">Submit</span>
                    </div>   
                </button>
                <ValidationError errors={state.errors} code={state.errors}  />
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
